import {TIPOSRETIRO} from "../../Constantes";

export const obtenerValorEntreagar = ({valor, tipo}) =>{

    let porcentaje = 10
    if (tipo === TIPOSRETIRO[0].nombre){
        porcentaje = TIPOSRETIRO[0].porcentaje
    }else{
        porcentaje = TIPOSRETIRO[1].porcentaje
    }

    let valorFinl = (valor * -1) -  ((valor * -1)) * porcentaje / 100

    return valorFinl

}